import { isArray } from 'lodash'
// 总计数展示
export default (data, show = false, isDark = false) => {
  if (show && isArray(data) && data.length > 1) {
    let total = null
    data.forEach((item) => {
      const value = Number(item.originValue)
      if (!Number.isNaN(value) && item.originValue !== null) {
        total += value
      }
    })
    const fn = data[0].formatFn
    total = total === null ? '-' : fn && fn(total)
    return `<span style="color: ${isDark ? 'rgba(199, 224, 255, 1)' : 'rgba(32, 36, 55, 1)'}; font-size: 12px; line-height: 150%">总计：${total}</span>`
  }
  return ''
}
